import { axios, Response } from '../index'

export const ReactionType = {
  LIKE: 'LIKE',
  CLAP: 'CLAP',
  LOVE: 'LOVE',
  FUNNY: 'FUNNY'
} as const
export type ReactionType = (typeof ReactionType)[keyof typeof ReactionType]

type CreateReactionResponse = {
  postId: number
  type: ReactionType
  userId: number
  companyId: string
  postReactionId: number
}

const createReaction = (body: {
  postId: number
  reactionType: ReactionType
}): Response<CreateReactionResponse> => {
  return axios.post('/v1/reactions', body)
}

export default createReaction
